module.exports = __webpack_public_path__ + "pc/img/about-global-person02.51010d50.png";